// extracted by mini-css-extract-plugin
export default {"wrapper":"RhCfL_PzxLt3Kam1z3kd","contentWrapper":"QfyUqySVLHamDDX8Sik4","title":"vpC7wX7Nc6bhHtL2UNZ_","content":"WAgzC4DzPK5Yt6PQMWzP"};